import styled from "styled-components";
import { AddNewProjectForm } from './../AddNewProject/Form.style';

export const AddNewOpinionForm = styled(AddNewProjectForm)``;